import { Box, Container, Paper, Typography } from "@mui/material";

export const InstructionsView = () => (
  <Container maxWidth="md">
    <Paper
      elevation={0}
      sx={{
        p: 4,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>
        How to Add New Events
      </Typography>

      <Typography variant="body1" sx={{ mb: 3 }}>
        The frontend fetches the latest events directly from the API on every page load. If your
        event is missing, you just need to ensure the relevant NuGet package has been published with
        the new event — the rest is handled automatically.
      </Typography>

      <Box component="ol" sx={{ pl: 2, "& li": { mb: 2 } }}>
        <li>
          <Typography variant="body1">
            Ensure your event has been added to the relevant NuGet package (
            <strong>
              <code>Wisr.Events</code>
            </strong>{" "}
            or{" "}
            <strong>
              <code>Application.Coordinator.Events</code>
            </strong>
            ) and a new version has been published.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            A scheduled pipeline runs at 9, 12, 3, and 6 (Mon - Fri) and automatically checks for
            new versions of these packages. When a new version is detected, it creates a pull
            request into <strong>develop</strong> for the{" "}
            <a href="https://dev.azure.com/directmoney/WISR/_git/Wisr.Bus.Intercept.Api">
              Wisr.Bus.Intercept.Api
            </a>{" "}
            project and auto-completes it.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            No manual changes to the API project are required.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            If you need the update sooner and cannot wait for the next scheduled run, you can
            manually trigger the pipeline:{" "}
            <a href="https://dev.azure.com/directmoney/WISR/_build?definitionId=820">Nuget Job</a>
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Once the API has been updated and deployed, refresh this page. Your new event will
            appear automatically.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            You should see a success toast confirming events were loaded from the live API. If the
            API is unreachable, the app will fall back to a bundled static version of the events.
          </Typography>
        </li>
      </Box>
    </Paper>
  </Container>
);
